module.exports = __webpack_public_path__ + "img/66_M8_flow_with_floods.f3de6b2c.jpg";